module.exports = __webpack_public_path__ + "img/4902720092081_2.16632725.jpg";